import { FC } from 'react';
import WarningRounded from '@mui/icons-material/WarningRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

export type TPanelLeftIconVariant = 'warning' | 'error';

type TProps = {
  show: boolean;
  variant: TPanelLeftIconVariant;
};

const PanelLeftIcon: FC<TProps> = ({ show, variant }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="br b--Primary-Primary-600 h-inherit width-56 bg-transparencies-primary-50025 flex items-center justify-center">
      {variant === 'error' && <CancelRoundedIcon className="error-red fs-24" />}
      {variant === 'warning' && <WarningRounded className="Status-Warning-Default fs-24" />}
    </div>
  );
};

export default PanelLeftIcon;
